
import {Component, Vue, Prop} from "vue-property-decorator";
import moment from "moment";
@Component({
    components: {},
})
export default class KeyReturningDate extends Vue {
    @Prop({default: false})
    public displayChooseHour: boolean;

    @Prop({default: null})
    public initalDate: any;

    private unite: any = {label: "h", text: "Hours"};
    private uniteToAdd: any = "h";
    private numberToAdd: number = 1;

    get items(): object[] {
        return [
            {
                label: "m",
                text: this.$tc("countDown.minutes", this.numberToAdd),
            },
            {
                label: "h",
                text: this.$tc("countDown.hours", this.numberToAdd),
            },
            {
                label: "d",
                text: this.$tc("countDown.days", this.numberToAdd),
            },
            {
                label: "w",
                text: this.$tc("countDown.weeks", this.numberToAdd),
            },
        ];
    }

    private validate() {
        let newTime: any;
        if (this.initalDate) {
            newTime = moment(this.initalDate).add(this.numberToAdd, this.uniteToAdd);
        } else {
            newTime = moment().add(this.numberToAdd, this.uniteToAdd);
        }
        this.$emit("validTime", newTime?.format("YYYY-MM-DDTHH:mm:ss"));
    }

    private changeValue(value) {
        this.uniteToAdd = value;
    }

    private cancel() {
        this.$emit("cancel");
    }

}
